import { createAction } from '@reduxjs/toolkit';

import { RegisteredToCommunityActionPayload } from './types';

export const communityActions = {
  community: {
    registeredToCommunity: createAction<RegisteredToCommunityActionPayload>('[Community] registered to community'),
  },
};
